import React from 'react';
import YoutubePlayer from '../../common/YoutubePlayer';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal(props) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>Сorporate React web service</h1>
			<p className='project-popup__description '>
				Staff was designed and developed to make life easier for employees.
				<br /> The web service supports three main roles: <i>administrator</i>,
				<i> employee</i>, and <i>Intern</i>. <br />
				Any user can sign up for Staff. After that, an administrator decides to
				either accept the registration to make this user a part of the team, assign
				him some role, or reject the registration. <br /> Employees can make various
				requests (vacation, sick leave, etc.), which an administrator will later
				process. <br /> Interns can also view their curriculum, which was created by
				their mentor, and manage its progress. <br />
				Also, web service was integrated with Slack API to make all information
				regarding requests sent in private messages on Slack.
			</p>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>
						React.js, Redux, Material UI, Slack API, Node.js + express, PostgreSQL +
						Sequelize
					</span>
				</p>
			</div>
			<div className='project-popup__videos'>
				<YoutubePlayer
					src='https://www.youtube.com/embed/WtltaUk9P5w'
					title='Сorporate React web service'
				/>
			</div>
			<div className='project-popup__buttons '>
				<CloseModalButton onClose={props.closeModal} />
			</div>
		</div>
	);
}
